module.exports = __webpack_public_path__ + "img/3.1c7abc1c.png";